export default __webpack_public_path__ + "locales/ar-SA/Settings.json?hash=b8f5726e7d78a3ffd4e8b8853f8aa000";